import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/cards/testimonial/rating/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/workspace/src/components/carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkflowSection"] */ "/workspace/src/components/workflow-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/workspace/src/sections/about/v1/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/sections/contact/v1/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/sections/cta/v2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/workspace/src/sections/hero/v1/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/sections/industries/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectSectionV4"] */ "/workspace/src/sections/project/v4/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/sections/service/v3/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/sections/solutions/v1/index.tsx");
